// A simple in-memory token manager to avoid race conditions with localStorage

let inMemoryToken = null;

const tokenManager = {
  setToken: (token) => {
    inMemoryToken = token;
    try {
      localStorage.setItem('token', token);
      // Also store in Supabase's expected location for compatibility
      if (token && token.startsWith('Bearer ')) {
        localStorage.setItem('supabase.auth.token', token.replace('Bearer ', ''));
      }
    } catch (e) {
      console.error('Failed to set token in localStorage', e);
    }
  },
  getToken: () => {
    if (inMemoryToken) {
      return inMemoryToken;
    }
    try {
      // First try our token
      let token = localStorage.getItem('token');
      if (token) return token;
      
      // Fallback to Supabase token
      const supabaseToken = localStorage.getItem('supabase.auth.token');
      if (supabaseToken) {
        return supabaseToken;
      }
      
      return null;
    } catch (e) {
      console.error('Failed to get token from localStorage', e);
      return null;
    }
  },
  removeToken: () => {
    inMemoryToken = null;
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('supabase.auth.token');
      localStorage.removeItem('sb-bqipvtwfipmucdvqteih-auth-token');
    } catch (e) {
      console.error('Failed to remove token from localStorage', e);
    }
  },
};

export default tokenManager;
